import { render, staticRenderFns } from "./SuperSyndicate.vue?vue&type=template&id=6c9d92e7&scoped=true&"
import script from "./SuperSyndicate.vue?vue&type=script&lang=js&"
export * from "./SuperSyndicate.vue?vue&type=script&lang=js&"
import style0 from "./Styles/SuperSyndicate.css?vue&type=style&index=0&id=6c9d92e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d92e7",
  null
  
)

export default component.exports